<template>
  <div>
    <el-dialog
      title="保险记录"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column label="起止日期" align="center" width="220">
            <template slot-scope="scope">
              {{ scope.row.startDate }} ~ {{ scope.row.endDate }}
            </template>
          </el-table-column>

          <el-table-column
            label="保险公司"
            prop="company"
            width="220"
            align="center"
          >
          </el-table-column>

          <el-table-column
            label="交强险"
            prop="forceUrl"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="downloadFile(scope.row.forceUrl)"
                >点击下载</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="商业险"
            prop="businessUrl"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="downloadFile(scope.row.businessUrl)"
                >点击下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-button
          type="primary"
          @click="addCarInsuranceInfoDialogVisible = true"
          >新增保险记录</el-button
        >

        <el-button @click="closeCarInsuranceInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增车险"
      :visible.sync="addCarInsuranceInfoDialogVisible"
      @close="closeAddCarInsuranceInfoDialog()"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="车牌号：">
          {{ this.selectCarInfo.carNum }}
        </el-form-item>

        <el-form-item label="车辆类型：">
          {{ this.selectCarInfo.carTypeName }}
        </el-form-item>

        <el-form-item label="起止日期：">
          <el-date-picker
            v-model="startEndTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="保险公司：">
          <el-input placeholder="请输入保险公司" v-model="company" />
        </el-form-item>

        <el-form-item label="交强险：">
          <el-upload
            class="file-uploader"
            action="#"
            :http-request="handlexlslFile1"
            :show-file-list="false"
            :before-upload="beforeFileUpload1"
          >
            <el-button size="medium" type="text">上传文件</el-button>
          </el-upload>

          {{ filename1 }}
        </el-form-item>

        <el-form-item label="商业险险：">
          <el-upload
            class="file-uploader"
            action="#"
            :http-request="handlexlslFile2"
            :show-file-list="false"
            :before-upload="beforeFileUpload2"
          >
            <el-button size="medium" type="text">上传文件</el-button>
          </el-upload>

          {{ filename2 }}
        </el-form-item>
      </el-form>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="addInsuranceSubmit()"
          >确 定</el-button
        >
        <el-button @click="closeAddCarInsuranceInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import {
  addInsurance,
  addRepair,
  listPageInsurance,
} from '@/api/equipmentmanagement';
import CommonFile from '@/api/common';

export default {
  name: 'CarInsuranceInfoDialog',

  props: {
    carInsuranceInfoDialogVisible: false,
    selectCarInfo: {},
  },
  watch: {
    carInsuranceInfoDialogVisible(val) {
      if (val) {
        this.getlistPageRepair();
      }
    },
  },

  computed: {
    visible: {
      get() {
        return this.carInsuranceInfoDialogVisible;
      },
      set(val) {
        if (!val) {
          this.$emit('closeEvent');
        }
      },
    },
  },
  data() {
    return {
      listLoading: false,
      dataList: [],

      addCarInsuranceInfoDialogVisible: false,

      startEndTime: '',
      company: '',

      filename1: '',
      uploadFile1: null,
      filename2: '',
      uploadFile2: null,
    };
  },
  methods: {
    closeCarInsuranceInfoDialog() {
      this.visible = false;
    },

    getlistPageRepair() {
      let req = {
        carId: this.selectCarInfo.carId,
        carNum: this.selectCarInfo.carNum,
        carType: this.selectCarInfo.carType,
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };

      listPageInsurance(req).then((result) => {
        this.dataList = result.data.data.records;
      });
    },
    async addInsuranceSubmit() {
      if (this.startEndTime === '') {
        this.$message.error('请选择日期');
        return;
      }
      if (this.company === '') {
        this.$message.error('请输入公司');
        return;
      }
      //上传文件
      if (this.filename1.length === 0) {
        this.$message.error('请选择交强险文件！');
        return;
      }
      //上传文件
      if (this.filename2.length === 0) {
        this.$message.error('请选择商业险文件！');
        return;
      }

      const file1Result = await CommonFile.commonUploadFile(
        'carmaintenance',
        this.uploadFile1.file
      );
      if (file1Result.data.code !== 200) {
        this.$message.error(file1Result.data.message);
        return;
      }

      const file2Result = await CommonFile.commonUploadFile(
        'carmaintenance',
        this.uploadFile2.file
      );
      if (file2Result.data.code !== 200) {
        this.$message.error(file2Result.data.message);
        return;
      }

      let req = {
        carId: this.selectCarInfo.carId,
        company: this.company,

        startDate: this.startEndTime[0],
        endDate: this.startEndTime[1],

        forceUrl: file1Result.data.data.filePath,
        businessUrl: file2Result.data.data.filePath,
      };
      // console.log(req)

      addInsurance(req).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: '提交成功', type: 'success' });

          this.closeAddCarInsuranceInfoDialog();
          this.getlistPageRepair();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },

    closeAddCarInsuranceInfoDialog() {
      this.startEndTime = '';
      this.company = '';
      this.filename1 = '';
      this.uploadFile1 = null;
      this.filename2 = '';
      this.uploadFile2 = null;
      //clean data
      this.addCarInsuranceInfoDialogVisible = false;
    },

    //上传文件
    handlexlslFile1(file) {
      this.uploadFile1 = file;
    },
    beforeFileUpload1(file) {
      this.filename1 = file.name;
      // console.log('文件名:', file.name);
    },

    //上传文件
    handlexlslFile2(file) {
      this.uploadFile2 = file;
    },
    beforeFileUpload2(file) {
      this.filename2 = file.name;
      // console.log('文件名:', file.name);
    },
    downloadFile(url) {
      const link = document.createElement('a');
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
  },
  created() {},
};
</script>
